import { render } from "./AddressSelector.vue?vue&type=template&id=647ae70c&scoped=true"
import script from "./AddressSelector.vue?vue&type=script&lang=js"
export * from "./AddressSelector.vue?vue&type=script&lang=js"

import "./AddressSelector.vue?vue&type=style&index=0&id=647ae70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647ae70c"]])

export default __exports__